export default "__VITE_ASSET__DNuY4DAw__"